module.exports = __webpack_public_path__ + "img/banner-1.583d3cba.png";